module.exports = __webpack_public_path__ + "aad1b9785aabf1ceaf37424a6139af43.svg";